module.exports = __webpack_public_path__ + "static/media/loaded_pass.5b8ec1e0.svg";